import $ from 'jquery';
import 'jcarousel';


function init() {
  $('.partners__listWrap')
  .on('jcarousel:reload jcarousel:create', function cb() {
    const carousel = $(this);
    let width = carousel.innerWidth();

    if (width >= 600) {
      width = width / 5;
    } else if (width >= 350) {
      width = width / 3;
    }
    carousel.jcarousel('items').css('width', `${Math.ceil(width)}px`);
  })
  .jcarousel({
    wrap: 'circular',
  });

  $('.partners__control_prev').jcarouselControl({ target: '-=1' });
  $('.partners__control_next').jcarouselControl({ target: '+=1' });
}

module.exports = { init };



/** WEBPACK FOOTER **
 ** ./src/blocks/partners/partners.js
 **/